import React from 'react';
import { Box, Button, Dialog, IconButton, Stack, Typography } from '@material-ui/core';
import { CloseOutlined, FormatSize } from '@material-ui/icons';
import Layout from './Layout';
import { useStoredState } from '../hooks/useStoredState';
import { FONT_SIZE_KEY } from '../utils/localStorage';
import String from './String';
import { useLanguage } from '../contexts/language';

const FontSizeSelector = ({ color }) => {
  const { content } = useLanguage();
  const [showMenu, setShowMenu] = React.useState(false);
  const [fontBaseSize, setFontBaseSize] = useStoredState({
    key: FONT_SIZE_KEY,
    defaultValue: 16,
  });

  React.useEffect(() => {
    document.documentElement.style.fontSize = `${fontBaseSize}px`;
  }, [fontBaseSize]);

  return (
    <Box padding={1}>
      <IconButton
        onClick={() => setShowMenu((prev) => !prev)}
        aria-label={content('aria_open_font_size')}
        title={content('aria_open_font_size')}
      >
        <FormatSize color={color ?? 'secondary'} style={{ fontSize: '1.25rem', ...(color && { color }) }} />
      </IconButton>

      <Dialog open={showMenu} onClose={() => setShowMenu(false)} aria-labelledby="font-size-dialog-title">
        <Layout framed>
          <Stack justifyContent="center" alignItems="center" gap={1} bgcolor="transparent">
            <IconButton
              onClick={() => setShowMenu(false)}
              aria-label={content('aria_close_font_size')}
              title={content('aria_close_font_size')}
              style={{ marginBottom: '2rem' }}
            >
              <CloseOutlined color="secondary" style={{ fontSize: '2rem' }} />
            </IconButton>

            <Typography id="font-size-dialog-title" variant="title" color="secondary" mb={2} borderBottom={1}>
              <String s="text_size" />
            </Typography>

            <Button
              my={1}
              color={fontBaseSize === 16 ? 'primary' : 'secondary'}
              variant={fontBaseSize === 16 ? 'contained' : 'text'}
              aria-pressed={fontBaseSize === 16}
              style={{ textTransform: 'uppercase' }}
              onClick={() => setFontBaseSize(16)}
            >
              <String s="standard" />
            </Button>

            <Button
              my={1}
              color={fontBaseSize === 18 ? 'primary' : 'secondary'}
              variant={fontBaseSize === 18 ? 'contained' : 'text'}
              aria-pressed={fontBaseSize === 18}
              style={{ textTransform: 'uppercase' }}
              onClick={() => setFontBaseSize(18)}
            >
              <String s="large" />
            </Button>

            <Button
              my={1}
              color={fontBaseSize === 21 ? 'primary' : 'secondary'}
              variant={fontBaseSize === 21 ? 'contained' : 'text'}
              aria-pressed={fontBaseSize === 21}
              style={{ textTransform: 'uppercase' }}
              onClick={() => setFontBaseSize(21)}
            >
              <String s="xlarge" />
            </Button>
          </Stack>
        </Layout>
      </Dialog>
    </Box>
  );
};

export default FontSizeSelector;
